import { useCreateFieldGetter } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';
import { guestFormBlockParams } from './useGuestFormCustomisation';

/**
 * Primary CTA (submit / verify / close) — `guest-form-actions` block.
 */
export const useGuestFormPrimaryActionButton = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    ...guestFormBlockParams,
    blockKey: PUI.GUEST_FORM_BLOCK_KEYS.GUEST_FORM_ACTIONS,
    sectionKey: PUI.GUEST_FORM_SECTION_KEYS.PRIMARY_ACTION_BUTTON,
  });

  const buttonText = getField(PUI.COMMON_FIELD_KEYS.BUTTON_TEXT);
  const buttonBackgroundColor = getField(PUI.COMMON_FIELD_KEYS.BUTTON_BACKGROUND_COLOR);
  const buttonBorderColor = getField(PUI.COMMON_FIELD_KEYS.BUTTON_BORDER_COLOR);
  const buttonTextColor = getField(PUI.COMMON_FIELD_KEYS.BUTTON_TEXT_COLOR);
  const disabledButtonBackgroundColor = getField(PUI.COMMON_FIELD_KEYS.DISABLED_BUTTON_BACKGROUND_COLOR);
  const disabledButtonBorderColor = getField(PUI.COMMON_FIELD_KEYS.DISABLED_BUTTON_BORDER_COLOR);
  const disabledButtonTextColor = getField(PUI.COMMON_FIELD_KEYS.DISABLED_BUTTON_TEXT_COLOR);

  return {
    isVisible,
    buttonText,
    buttonBackgroundColor,
    buttonBorderColor,
    buttonTextColor,
    disabledButtonBackgroundColor,
    disabledButtonBorderColor,
    disabledButtonTextColor,
  };
};
